import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import TopTwenty from './TopTwenty';
import TopTwentyView from './TopTwentyView';
import TopTwentyForm from './TopTwentyForm';

storiesOf('Case Menu/Schedule Forms/TopTwenty', module)
  .add('Loading', () => (
    <div>
      <h3>Component can be in a loading state while we fetch data</h3>
      <hr/>
      <TopTwenty loading={ true } />
    </div>
  ))

  .add('View', () => (
    <div>
      <h3>By default, we show a view form with search fields</h3>
      <hr/>

      <TopTwenty
        canEdit={false}
        onSaveSchedule={ action('onSaveSchedule') }
        top_twenty={sampleTopTwentyWithData}
      />
    </div>
  ))

  .add('View without data', () => (
    <div>
      <h3>Before data is entered, we should display the empty message that server sends</h3>
      <hr/>

      <TopTwenty
        canEdit={false}
        onSaveSchedule={ action('onSaveSchedule') }
        top_twenty={sampleTopTwentyEmpty}
      />
    </div>
  ))

  .add('View (Editable)', () => (
    <div>
      <h4>When allowed to, we show the edit button.</h4>
      <h4>Clicking the edit button should bring up the editor form</h4>
      <h4>Saving in the editor results in <code>onSaveSchedule</code> being called with new data</h4>
      <h4>(initial data below is when no data is entered yet, but edit should form even when there is data)</h4>
      <hr/>

      <TopTwenty
        canEdit={true}
        onSaveSchedule={ action('onSaveSchedule') }
        top_twenty={sampleTopTwentyEmpty}
      />
    </div>
  ))

  .add('Top Twenty Editor Form', () => (
    <div>
      <h3>Editor form contains buttons to add / remove priority and non-priority creditors</h3>
      <h4>It emits <code>onSubmit</code> and <code>onCancel</code> events</h4>
      <h4>It should ask for confirmation when:</h4>
      <ul>
        <li>removing a creditor</li>
        <li>cancelling a form that has edits</li>
      </ul>
      <hr/>
      <TopTwentyForm
        onSubmit={ action('onSubmit') }
        onCancel={ action('onCancel') }
        data={sampleTopTwentyWithData.data}
      />
    </div>
  ))

const sampleTopTwentyEmpty = {
  empty: 'There is no Top Twenty for this case.'
}


const sampleTopTwentyWithData = {
  data: {
    creditors: [
      {
        "name_addr": "IRS\nP.O. Box 7346\nPhiladelphia, PA 19101",
        "contact_addr": "",
        "claim_type": "Back Taxes",
        "claim_status": "",
        "total": "12000.00",
        "deduction": "0.00",
        "unsecured": "0.00"
      },
      {
        "name_addr": "Buchanan's Accounting & Tax Service\n537 Royal Palm Beach Blvd.\nWest Palm Beach, FL 33411",
        "contact_addr": "212-906-1200\ndj.baker@lw.com",
        "claim_type": "Bank Loans",
        "claim_status": "Disputed",
        "total": "",
        "deduction": "0.00",
        "unsecured": "990.00"
      },
      {
        "name_addr": "Commerical Truck Repair\n837 West 13th Street\nWest Palm Beach, FL 33404",
        "contact_addr": "",
        "claim_type": "Trade Debts",
        "claim_status": "Contingent",
        "total": "",
        "deduction": "0.00",
        "unsecured": "4124.33"
      },
      {
        "name_addr": "Ernest Burrs Jr\n2642 West 28th Street\nRivera Beach, FL 33404",
        "contact_addr": "",
        "claim_type": "",
        "claim_status": "Unliquidated",
        "total": "",
        "deduction": "0.00",
        "unsecured": "Unknown"
      }
    ]
  }
}




/** WEBPACK FOOTER **
 ** ./src/scheduleform/TopTwenty.stories.jsx
 **/